export const handleSetWAIntegrationDetails = (set) => (data) => {
  set((state) => ({ ...state, details: { ...state.details, ...data } }));
};
